/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/scooter_medium'
export default icon
